import React from 'react';
import { Card } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { LinearChartOptionsBuilder } from 'components/insights/linear-chart/linear-chart-options-builder';
import type { TLinearChartProps } from 'components/insights/linear-chart/types';

export const LinearChart: React.FC<TLinearChartProps> = (props) => {
  const {
    title,
    withOppositeYAxis,
    mainSeries,
    comparisonSeries,
    yAxisOppositeTitle,
    yAxisTitle,
    highlightWeekends,
    comparisonLineStyle,
  } = props;
  const optionBuilder = new LinearChartOptionsBuilder({
    highlightWeekends,
    comparisonLineStyle,
    withOppositeYAxis,
    yAxisTitle,
    yAxisOppositeTitle,
    mainSeries,
    comparisonSeries,
  });

  return (
    <Card title={title}>
      <HighchartsReact highcharts={Highcharts} options={optionBuilder.options} />
    </Card>
  );
};
